import { boatV2ServiceApi } from '@/shared/api/boat-v2-service.api';
import { AppStoreTag } from '@/shared/constants/app-store-tag.constant';
import { Pagination } from '@/shared/lib/interfaces/pagination.interface';

import { transformOrganizationYachtResponse } from '../model/helpers/transform-organization-yacht-response.helper';
import { OrganizationYacht } from '../model/types/boat.interface';
import {
	GetOrganizationYachtVariables,
	OrganizationYachtResponse,
	OrganizationYachtsApiVariables,
} from '../model/types/boat-api.interface';

const organizationYachtsApi = boatV2ServiceApi.injectEndpoints({
	endpoints: (build) => ({
		getYachts: build.query<Pagination<OrganizationYacht>, OrganizationYachtsApiVariables>({
			providesTags: [AppStoreTag.Boat],
			query: ({ organizationNodeId, teamNodeId, search, status, account, page, size }) => {
				const params = new URLSearchParams({
					page: String(page),
					size: String(size),
				});

				if (organizationNodeId) params.set('organization_node_id', organizationNodeId);
				if (teamNodeId) params.set('team_node_id', teamNodeId);
				if (search) params.set('search', search);
				if (status) params.set('status', status);
				if (account) params.set('account_id', account);

				return {
					method: 'GET',
					url: `yachts?${params.toString()}`,
				};
			},
			transformResponse: (
				response: Pagination<OrganizationYachtResponse>,
				_,
				{ timezone },
			): Pagination<OrganizationYacht> => ({
				...response,
				items: response.items.map((yacht) => transformOrganizationYachtResponse(yacht, timezone)),
			}),
		}),
		getOrganizationYacht: build.query<OrganizationYacht, GetOrganizationYachtVariables>({
			providesTags: (_result, _error, { yachtId }) => [{ type: AppStoreTag.Boat, id: yachtId }],
			query: ({ yachtId }) => ({
				method: 'GET',
				url: `yachts/${yachtId}`,
			}),
			transformResponse: (response: OrganizationYachtResponse, _, { timezone }) =>
				transformOrganizationYachtResponse(response, timezone),
		}),
	}),
});

export const { useGetYachtsQuery, useGetOrganizationYachtQuery } = organizationYachtsApi;
